import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, TextField, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import feedbackService from '../../services/feedback_service';

function DetailFeedback() {
  const [feedback, setFeedback] = useState(null);
  const [reply, setReply] = useState('');
  const navigate = useNavigate();

  const { id } = useParams();

  useEffect(() => {
    const fetchFeedback = async () => {
      const feedbackData = await feedbackService.getOneFeedback(id);
      setFeedback(feedbackData.data);
      if (feedbackData.data.reply) {
        setReply(feedbackData.data.reply);
      }
    };

    fetchFeedback();
  }, [id]);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleReplyChange = (event) => {
    setReply(event.target.value);
  };
  
  const getReplyStatusText = (reply) => {
    return reply === null ? 'Unfinished' : 'Finished';
  };

  const getReplyDateText = (replyDate) => {
    return replyDate ? new Date(replyDate).toLocaleDateString() : 'Not replied yet';
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();

    const replyDate = new Date();
    const formatDate = replyDate.toISOString().slice(0, 19).replace('T', ' ');

    const replyData = {
      reply: reply,
      email: feedback.email,
      body: feedback.body,
      subject: feedback.subject,
      type: feedback.type,
      reply_date: formatDate
    };

    
    try {
      const response = await feedbackService.updateOneFeedback(id, replyData);
      console.log('Response:', response);
      
      if (response.status === 200) {
        alert("Feedback reply sent successfully");
        navigate(-1);
      } else {
        alert("An error occurred while sending the reply");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while sending the reply");
    }
  }
  
  const getTypeText = (type) => {
    switch(type){
      case 1: return 'Feedback';
      case 2: return 'Request';
      case 3: return 'Bug';
      case 4: return 'Complaint';
      case 5: return 'Other';
      default: return '';
    }
  };
  
  if (!feedback) {
    return 'Loading...';
  }

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manage Feedback" />
      </Box>

      <Box sx={{ marginLeft:'280px', marginRight:'50px', p: 2 }}>
        <h2>Feedback details</h2>
        <p>ID: {feedback.id}</p>
        <p>Email member: {feedback.email}</p>
        <p>Type: {getTypeText(feedback.type)}</p>
        <p>Date: {new Date(feedback.created_date).toLocaleDateString()}</p>
        <p>Reply Status: {getReplyStatusText(feedback.reply)}</p>
        <p>Replied Date: {getReplyDateText(feedback.reply_date)}</p>
        <p style={{fontWeight: 'bold'}} >Subject: {feedback.subject}</p>
        <p style={{fontWeight: 'bold'}}>Body: {feedback.body}</p>

        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required={!feedback.reply}
              fullWidth
              label="Reply"
              value={reply}
              onChange={handleReplyChange}
              variant="outlined"
              multiline
              rows={4}
              disabled={!!feedback.reply}
            />
          </Box>

          <Button type="submit" variant="contained" sx={{ boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white' }} disabled={!!feedback.reply}>
            {feedback.reply ? "Finished" : "Send Reply"}
          </Button>
          <Button variant="contained" sx={{ left:10 , boxShadow: 5, textTransform: 'none', bgcolor: '#FF5630', color: 'white' }} onClick={handleCancel}>Cancel</Button>
        </form>
      </Box>
    </>
  );
}

export default DetailFeedback;
